/**
 * Public API barrel for the shared Proposal DeficienciesStep feature (task-03/04).
 *
 * Import the list component, types, mapper, and filter defaults from here
 * rather than from deep paths.
 */
export { DeficienciesList } from './DeficienciesList';
export { MassActions, proposalDeficiencyKeys } from './MassActions';
export { DEFAULT_DEFICIENCY_FILTERS } from './types';
export { mapApiRowToViewModel } from './mapper';
